module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Exchange-d30ffebdf03110449f479f05b3f49089.svg";